<div class="container-fluid">
  <div class="row questionnaireButton">
    <div class="col-4 d-flex align-items-center">
      <span class="blueColoredText fs-14-vw fw-600">Questionnaire</span>
    </div>
    <div class="col-8 d-flex justify-content-end align-items-center py-2-vw">
      <div
        class="cursor secondaryButton fs-12-vw fw-500 px-1-vw py-1-vw"
        (click)="downloadExcel()"
      >
        <img
          src="../../../../../assets/images/download-2-line.png"
          alt="Download icon"
        />
        Download Excel
      </div>
      <div
        class="cursor primaryButton text-white fs-12-vw fw-500 ms-2-vw px-1-vw py-1-vw"
        (click)="LogEmailRequestSupplierQuestionnaire()"
        *ngIf="!sendToSupplierButtonDisabled"
      >
        <img
          src="../../../../../assets/images/mail-fill.png"
          alt="Email icon"
        />
        Send To Supplier
      </div>
      <div
        class="cursor secondaryButton fs-12-vw fw-500 ms-2-vw px-1-vw py-1-vw"
        (click)="scrollToNextUnfilled()"
      >
        <img
          src="../../../../../assets/images/skip-right-line.png"
          alt="skip icon"
        />
        Next Question
      </div>
    </div>
  </div>
  <div class="row">
    <div
      class="col-12 table-scroll-container tableFixHead mt-3-vw px-0"
      [ngClass]="{ tableFullHeight: sendToSupplierButtonDisabled }"
    >
      <table class="table table-strip mb-0">
        <thead>
          <tr class="table-child-container text-center">
            <th id="tableHeader" style="width: 12% !important">Topic</th>
            <th id="tableHeader" style="width: 25% !important">Questions</th>
            <th id="tableHeader" style="width: 3% !important">Yes</th>
            <th id="tableHeader" style="width: 5% !important">Partially</th>
            <th id="tableHeader" style="width: 3% !important">No</th>
            <th id="tableHeader" style="width: 15% !important">Remark</th>
            <th id="tableHeader" style="width: 29% !important">Document</th>
          </tr>
        </thead>
        <tbody class="mb-2-vw">
          <tr
            #questionRow
            class="py-2-vw"
            *ngFor="let row of supplierQuestionList; let parentIndex = index"
          >
            <td>{{ row.topic }}</td>

            <td>
              <div class="d-flex">
                <b>{{ parentIndex + 1 }}.</b>
                <div class="ps-1-vw" [innerHTML]="row.question"></div>
              </div>
            </td>
            <td class="text-center">
              <input
                (change)="fieldTouched()"
                [(ngModel)]="row.answer"
                type="radio"
                name="answer-{{ row.question }}"
                value="Yes"
                class="shadow-none"
              />
            </td>
            <td class="text-center">
              <input
                (change)="fieldTouched()"
                [(ngModel)]="row.answer"
                type="radio"
                name="answer-{{ row.question }}"
                value="Partially"
                class="shadow-none"
              />
            </td>
            <td class="text-center">
              <input
                (change)="fieldTouched()"
                [(ngModel)]="row.answer"
                type="radio"
                name="answer-{{ row.question }}"
                value="No"
                class="shadow-none"
              />
            </td>
            <td>
              <select
                *ngIf="!row.isRemarkFieldChangedToText"
                [ngClass]="{ 'custom-error': row.hasError }"
                class="form-control cursor h32 select-carot shadow-none fs-13-vw fw-500"
                name=""
                id=""
                [(ngModel)]="row.remark"
                (change)="
                  supplierRemarkListChange($event, parentIndex);
                  row.hasError = false;
                  fieldTouched()
                "
              >
                <option value="" selected>Select Remark</option>
                <option
                  value="{{ item?.remark }}"
                  *ngFor="let item of supplierRemarkList"
                >
                  {{ item?.remark }}
                </option>
              </select>

              <ng-container *ngIf="row.isRemarkOtherValueSelected">
                <textarea
                  [ngClass]="{ 'custom-error': row.hasError }"
                  rows="2"
                  name=""
                  id=""
                  (input)="fieldTouched()"
                  [(ngModel)]="row.otherRemark"
                  placeholder="Enter remark"
                  class="form-control shadow-none fs-13-vw fw-500 mt-2-vw"
                ></textarea>
              </ng-container>
              <!-- 'custom-error': checkingError && row.answer && !row.remark -->
              <ng-container *ngIf="row.isRemarkFieldChangedToText">
                <textarea
                  [ngClass]="{
                    'custom-error': row.hasError
                  }"
                  rows="2"
                  name=""
                  id=""
                  [(ngModel)]="row.remark"
                  placeholder="Enter remark"
                  (change)="fieldTouched()"
                  class="form-control shadow-none fs-13-vw fw-500"
                ></textarea>
              </ng-container>
            </td>
            <td>
              <div
                class="d-flex justify-content-end"
                *ngFor="let item of row?.fileData; let childIndex = index"
              >
                <ng-container *ngIf="!item.documentTypeId || !item.fileName">
                  <select
                    [(ngModel)]="item.documentTypeId"
                    (change)="removeErrorForDocType(row)"
                    class="form-control cursor select-carot h32 shadow-none fs-13-vw fw-500 w-50 mb-2-vw"
                    name=""
                    id=""
                    [ngClass]="{ 'custom-error': row.hasDocTypeError }"
                  >
                    <option value="null" selected disabled>
                      Select Document Type
                    </option>
                    <option
                      value="{{ item?.id }}"
                      *ngFor="let item of supplierDocumentTypeList[parentIndex]"
                    >
                      {{ item?.documentType }}
                    </option>
                  </select>

                  <div
                    class="uploadIcon cursor h32 d-flex align-items-center justify-content-center mx-2-vw"
                  >
                    <label
                      [for]="
                        item.documentTypeId
                          ? 'fileInput-' + parentIndex + '-' + childIndex
                          : ''
                      "
                      class="blueColoredText py-1-vw px-2-vw fs-13-vw fw-600 cursor fileDiv text-center"
                      [ngClass]="{ 'custom-error': row.hasDocError }"
                      (click)="onUploadClick($event, row)"
                    >
                      <img
                        id="imageCursor"
                        src="../../../../../assets/images/download_icon.png"
                        alt=""
                        srcset=""
                      />
                      Upload
                    </label>

                    <input
                      type="file"
                      [id]="'fileInput-' + parentIndex + '-' + childIndex"
                      name=""
                      style="display: none"
                      (change)="
                        onFileSelected($event, parentIndex, childIndex, row)
                      "
                      [accept]="
                        this.uploadDocumentConfiguration?.DocumentExtensions
                      "
                    />
                  </div>
                  <div
                    *ngIf="row?.fileData?.length != childIndex + 1"
                    class="border w31 cursor h32 d-flex align-items-center justify-content-center mx-1-vw"
                    (click)="
                      deleteFileDataInTable(
                        parentIndex,
                        childIndex,
                        row.categoryId,
                        row.id,
                        item.documentTypeId
                      )
                    "
                  >
                    <img
                      src="../../../../../assets/images/delete_box_icon.png"
                      alt=""
                    />
                  </div>
                  <div
                    *ngIf="row?.fileData?.length == childIndex + 1"
                    class="border w31 cursor h32 d-flex align-items-center justify-content-center mx-1-vw"
                    (click)="
                      addMoreFileDataInTable(parentIndex); isFieldTouched = true
                    "
                  >
                    <img
                      src="../../../../../assets/images/add_icon.png"
                      alt=""
                    />
                  </div>
                </ng-container>

                <ng-container *ngIf="item.documentTypeId && item.fileName">
                  <div
                    class="fs-13-vw fw-500 d-flex justify-content-between align-items-center form-control shadow-none h32 mb-2-vw"
                    style="width: 20vw"
                    [ngClass]="{ 'custom-error': row.hasDocError }"
                  >
                    <span class="text-truncate"
                      >{{ item?.documentTypeName }} :
                    </span>
                    <div
                      class="d-flex align-items-center justify-content-end w-50"
                    >
                      <span
                        [matTooltip]="
                          item?.fileName && item?.filepath && 'Preview File'
                        "
                        matTooltipPosition="above"
                        matTooltipShowDelay="300"
                        class="text-truncate1 blueColoredText ms-1-vw cursor"
                        (click)="
                          item?.filepath
                            ? previewDocumentModal.openPreviewDocument(
                                item?.filepath
                              )
                            : ''
                        "
                        >{{ item?.fileName }}</span
                      >
                      <img
                        src="../../../../../assets/images/close_icon_blue.png"
                        alt="Remove Icon"
                        class="cross-icon cursor absolute"
                        (click)="
                          item.documentTypeId
                            ? confirmationDialog('delete', {
                                parentIndex: parentIndex,
                                childIndex: childIndex,
                                file: true,
                                categoryId: row.categoryId,
                                id: row.id,
                                documentTypeId: item.documentTypeId
                              })
                            : DeleteQuestionnaireSingleDocument(
                                parentIndex,
                                childIndex,
                                row.categoryId,
                                row.id,
                                item.documentTypeId
                              )
                        "
                      />
                    </div>
                    <!-- _commonService.openDocument(item?.filepath) -->
                  </div>
                  <div
                    *ngIf="row?.fileData?.length != childIndex + 1"
                    class="border w31 cursor h32 d-flex align-items-center justify-content-center mx-1-vw"
                    (click)="
                      deleteFileDataInTable(
                        parentIndex,
                        childIndex,
                        row.categoryId,
                        row.id,
                        item.documentTypeId
                      )
                    "
                  >
                    <img
                      src="../../../../../assets/images/delete_box_icon.png"
                      alt=""
                    />
                  </div>
                  <div
                    *ngIf="row?.fileData?.length == childIndex + 1"
                    class="border w31 cursor h32 d-flex align-items-center justify-content-center mx-1-vw"
                    (click)="addMoreFileDataInTable(parentIndex)"
                  >
                    <img
                      src="../../../../../assets/images/add_icon.png"
                      alt=""
                    />
                  </div>
                </ng-container>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div id="saveButtonDiv" class="row m-0 p-0">
    <div
      class="col-12"
      style="
        width: -webkit-fill-available;
        text-align: end;
        position: fixed;
        bottom: 5px;
        z-index: 1;
        padding: 0 1.389vw;
      "
    >
      <div class="row d-flex justify-content-end">
        <div class="d-flex justify-content-end">
          <button
            [ngClass]="{ cursorDisabled: !isFieldTouched }"
            type="button"
            id="saveModalButton1"
            (click)="isFieldTouched ? saveQuestionerData() : ''"
            class="primaryButton btn rounded fs-13-vw fw-400"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- START: Preview Document  -->
<app-preview-document-modal></app-preview-document-modal>
<!-- END: Preview Document  -->
